import { render, staticRenderFns } from "./DashboardLoader.vue?vue&type=template&id=26362532&scoped=true&"
import script from "./DashboardLoader.vue?vue&type=script&lang=ts&"
export * from "./DashboardLoader.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardLoader.vue?vue&type=style&index=0&id=26362532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26362532",
  null
  
)

export default component.exports